export default __webpack_public_path__ + "media/images/paylogos/gray/mastercard_electronic@2x-489da23d7d7722b5b6918c56c2f8c672.png";